import { useMutation } from 'react-query';

import { checkSAML } from '../../lib/api';

export function useMutateCheckSAML() {
  return useMutation(checkSAML);
}
